import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

// import  CommercialSection  from "./styles/CommercialSection.styled";
import { Footer } from './styles/Footer.styled.js';
import { NavBar } from './styles/NavBar.styled.js';
// import CleaningOperation from './styles/CleaningOperation.styled.js';
import { SectorSpecialist } from './styles/SectorSpecialist.styled.js';
import { Accordion, AccordionContent } from './styles/Accordion.styled.js';
import { OurColleagues } from './styles/OurColleagues.styled.js';
import OurCleaningService from './styles/OurCleaningService.styled.js';
import { Reviews } from './styles/Reviews.styled.js';
import sheffield from './assets/sheffield.jpg';
import img1 from './assets/img1.jpg';
import img2 from './assets/img2.jpg';
import img3 from './assets/img3.jpg';
// import Cleaning from './assets/pexels-karolina-grabowska-4239032.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { ShowCaseCommercial } from './styles/ShowCase.styled.js';

// or from '@fortawesome/free-regular-svg-icons' depending on the style you want

// const stats = [
//   {
//     icon: 'fa-solid fa-soap',
//     target: 2,
//     suffix: 'Yrs',
//     text: 'Cleaning history and market leadership',
//   },
//   {
//     icon: 'fa-solid fa-earth-europe',
//     target: 58,
//     suffix: '+',
//     text: 'colleagues across the UK',
//   },
//   {
//     icon: 'fa-solid fa-arrows-down-to-people',
//     target: 35,
//     suffix: '+',
//     text: 'In-house colleagues in our cleaning team',
//   },
//   {
//     icon: 'fa-solid fa-recycle',
//     target: 3,
//     suffix: '+',
//     text: 'Tonnes of refuse collected for recycling',
//   },
// ];

const CommercialCleaning = () => {
  //Title Page
  useEffect(() => {
    document.title = 'Commercial - Cleaning operation in numbers';
  }, []);

  const [offsetRev, setOffsetRev] = useState(0);

  // const [counts, setCounts] = useState(stats.map(() => 0));

  const reviews = [
    {
      img: sheffield,
      title: 'End of Tenancy Cleaning',
      text: '"Did a very Perfect job, Thank you."',
      name: 'Jamie',
      location: 'Sheffield',
    },
    {
      img: sheffield,
      title: 'One Time Cleaning',
      text: '"Cleaner was very fast and does the job well."',
      name: 'Nada',
      location: 'Sheffield',
    },
    {
      img: sheffield,
      title: 'Deep Cleaning',
      text: '"Thank you for the amazing job raf.. My house is now sparkling."',
      name: 'Carshena',
      location: 'Sheffield',
    },
    {
      img: sheffield,
      title: 'Move In Cleaning',
      text: '"My house now looks perfect, will keep on using you weekly. Thanks Raf."',
      name: 'Myles W',
      location: 'Chesterfield',
    },
    {
      img: sheffield,
      title: 'Carpet Cleaning',
      text: '"Amazing job guys!"',
      name: 'Linda',
      location: 'Nottingham',
    },
    {
      img: sheffield,
      title: 'After Renovation Cleaning',
      text: '"My Dad said you did a good jobThank you guys "',
      name: 'Nevila',
      location: 'Sheffield',
    },
    {
      img: sheffield,
      title: 'Oven Cleaning',
      text: '"I would rate you very good. I had a quick response from you.I was very pleased with the work done & would recommend. Thank you "',
      name: 'June S.',
      location: 'Stockport',
    },
  ];

  const handleNextRev = () => {
    if (offsetRev < reviews.length - 2) {
      // show 3 at a time
      setOffsetRev(offsetRev + 1);
    }
  };

  const handlePrevRev = () => {
    if (offsetRev > 0) {
      setOffsetRev(offsetRev - 1);
    }
  };

  // useEffect(() => {
  //   const timers = stats.map((stat, index) => {
  //     const increment = Math.ceil(stat.target / 100); // Adjust speed by changing divisor
  //     return setInterval(() => {
  //       setCounts((prev) => {
  //         const newCounts = [...prev];
  //         if (newCounts[index] < stat.target) {
  //           newCounts[index] = Math.min(
  //             newCounts[index] + increment,
  //             stat.target
  //           );
  //         }
  //         return newCounts;
  //       });
  //     }, 30); // Adjust interval for animation speed
  //   });

  //   return () => timers.forEach((timer) => clearInterval(timer));
  // }, []);

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const items = [
    {
      question: 'What types of cleaning services do you offer?',
      answer:
        'We provide comprehensive cleaning solutions, including janitorial, deep cleaning, floor care, carpets, windows, sanitation, and specialized industry services—tailored to meet each client’s unique requirements.',
    },
    {
      question: 'Do you use environmentally friendly cleaning products?',
      answer:
        'Yes, we consistently prioritize eco-friendly practices, utilizing sustainable cleaning solutions and equipment that meet industry standards, ensuring healthier environments while supporting your organization’s long-term sustainability goals.',
    },
    {
      question:
        'How do you ensure quality and consistency in your cleaning services?',
      answer:
        'We uphold quality and consistency through rigorous training programs, detailed checklists, regular inspections, and structured feedback mechanisms, ensuring our cleaning services consistently meet and exceed customer expectations.',
    },
    {
      question:
        'Can you accommodate our facility’s schedule for cleaning services?',
      answer:
        'Absolutely. we recognize that facilities have unique schedules and requirements. Our flexible service options ensure cleaning is delivered at times that align seamlessly with your operations, without disruption.',
    },
    {
      question:
        'What measures do you have in place for security and confidentiality during cleaning services?',
      answer:
        'Our team goes through background checks and signs confidentiality agreements to keep your facility and sensitive information secure. We follow strict protocols to protect your property and ensure confidentiality every step of the way.',
    },
    {
      question:
        'What steps do you take to ensure health and safety standards are met during cleaning?',
      answer:
        'We prioritize health and safety in all cleaning procedures, providing ongoing training, enforcing strict safety protocols, and utilizing appropriate Personal Protective Equipment to ensure safe, reliable, and compliant practices across our operations.',
    },
    {
      question:
        'Can you accommodate special cleaning requirements or specific areas that need extra attention?',
      answer:
        'Of course—we know every facility has its own needs. Whether it’s busy areas, sensitive spaces, or specialized cleaning, our team is ready to handle it. We’ll work closely with you to identify and prioritize the spots that need extra care.',
    },
    {
      question: 'How do you handle emergencies or last-minute cleaning needs?',
      answer:
        'We’ve got a dedicated team on call 24/7 to handle emergencies or urgent cleaning needs. Whether it’s spills or unexpected situations, we respond quickly and efficiently to keep your operations running smoothly with minimal disruption.',
    },
    {
      question:
        'Can you provide examples or case studies of your cleaning work in similar businesses or industries?',
      answer:
        'Certainly. We have a track record of successful cleaning contracts across various industries, and we can provide references or case studies to illustrate our expertise and the effectiveness of our cleaning solutions. Please get in touch – we’d love to share them with you.',
    },
  ];

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
      </Helmet>
      <NavBar></NavBar>
      <ShowCaseCommercial>
        <div className="center">
          <div className="titleBox">
            <h1>Commercial Cleaning Services</h1>
            <p>
              Our data‑driven cleaning strategies are tailored to your business,
              ensuring your facility remains safe, compliant, and fully prepared
              to deliver optimal outcomes.
            </p>
          </div>
        </div>
      </ShowCaseCommercial>
      {/* <CleaningOperation>
        <div className="container">
          <div className="row">
            <div className="header">
              <h1>Our Operation in Numbers</h1>
              <p>
                We create healthier spaces by making cleaning, hygiene, and
                infection control the foundation of wellbeing and productivity.
              </p>
            </div>
            <div className="cleaning">
              <ul>
                {stats.map((stat, index) => (
                  <li key={index}>
                    <i>
                      <i className={stat.icon}></i>
                    </i>
                    <h3>
                      {Math.floor(counts[index])}
                      {stat.suffix}
                    </h3>
                    <p>{stat.text}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </CleaningOperation> */}
      <OurCleaningService>
        <div className="container">
          <div className="row">
            <div className="col_1">
              <a
                href="https://www.freepik.com/free-photo/full-shot-man-pushing-elevator-button_24492577.htm#fromView=search&page=1&position=6&uuid=53018557-8577-4ec9-beaf-ec9ae2ec5c26&query=facility+cleaning"
                target="_blank"
                rel="noreferrer"
              >
                <img src={img1} alt="" />
              </a>
            </div>
            <div className="col_2">
              <h1>Our cleaning services</h1>
              <p>
                Our global cleaning teams are dedicated to ensuring that people
                and places consistently achieve their highest standards,
                operating across thousands of locations, multiple times each
                day, throughout the year. With a legacy of 2 years in cleaning
                innovation, we are committed to building meaningful connections
                and look forward to discussing how our expertise can best
                support your organization.
              </p>
              <p>
                Contact our team to find out more detail on any of the service
                areas below:
              </p>
              <ul>
                <li>Office & Communal Spaces</li>
                <li>Leisure & Retail</li>
                <li>Restroom Sanitation </li>
                <li>Education & Public </li>
              </ul>
              <a href="/contact" className="button">
                Contact Our Team
              </a>
            </div>
          </div>
        </div>
      </OurCleaningService>
      <SectorSpecialist>
        <div className="container">
          <div className="row">
            <div className="col_2">
              <h1>Sector-specialist cleaning and hygiene services</h1>
              <p>
                Our responsibility is to ensure that your environment remains
                clean, fresh, sanitized, and fully prepared for the demands of
                each day. We recognize that maintaining a safe, hygienic, and
                infection-free environment can be the decisive factor that
                enables success.
              </p>
            </div>
            <div className="col_1">
              <a
                href="https://www.freepik.com/free-photo/full-shot-men-cleaning-office_24492575.htm#fromView=search&page=1&position=3&uuid=53018557-8577-4ec9-beaf-ec9ae2ec5c26&query=facility+cleaning"
                target="_blank"
                rel="noreferrer"
              >
                <img src={img2} alt="responsibility" />
              </a>
            </div>
          </div>
        </div>
      </SectorSpecialist>
      <OurColleagues>
        <div className="container">
          <div className="row">
            <div className="col_1">
              <img src={img3} alt="Operation" />
            </div>
            <div className="col_2">
              <h1>Our colleagues at the centre of your operation</h1>
              <p>
                Our cleaning teams collaborate closely with clients and their
                staff, aligning our services with each organization’s mission
                and objectives. With a strong focus on delivering measurable
                outcomes, our teams play a vital role in implementing best
                practices and ensuring operational resilience. Working in unity,
                our teams support one another to ensure that all colleagues
                complete their shifts together.
              </p>
            </div>
          </div>
        </div>
      </OurColleagues>
      <Reviews offsetRev={offsetRev}>
        <div className="container">
          <div className="heading">
            <h3>Client Feedback</h3>
            <h1>Comments From Clients</h1>
          </div>
          <div className="carousel-container">
            <div className="carousel">
              {reviews.map((review, i) => (
                <div className="card" key={i}>
                  <img src={review.img} alt={review.title} />
                  <div className="content">
                    <div className="content_header">
                      <h3>{review.title}</h3>
                      <FontAwesomeIcon
                        icon={faCircleCheck}
                        className="plusIcon"
                      />
                    </div>
                    <p>{review.text}</p>
                    <p>
                      - {review.name}, {review.location}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="carousel-button left-button"
              onClick={handlePrevRev}
            >
              &#10094;
            </button>
            <button
              className="carousel-button right-button"
              onClick={handleNextRev}
            >
              &#10095;
            </button>
          </div>
        </div>
      </Reviews>
      <Accordion>
        <div className="container">
          <div className="row">
            <h1>Frequently asked questions for Cleaning</h1>
            <div className="accordion">
              {items.map((item, index) => (
                <div className="accordion-items" key={index}>
                  <button
                    className="accordionButton"
                    onClick={() => toggleAccordion(index)}
                  >
                    <h3>{item.question}</h3>
                    <div className="iconWrapper">
                      {openIndex !== index && (
                        <FontAwesomeIcon icon={faPlus} className="btn" />
                      )}
                      {openIndex === index && (
                        <FontAwesomeIcon icon={faMinus} className="btn" />
                      )}
                    </div>
                  </button>
                  <AccordionContent isOpen={openIndex === index}>
                    <p>{item.answer}</p>
                  </AccordionContent>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Accordion>
      {/* Footer */}
      <Footer></Footer>
    </>
  );
};

export default CommercialCleaning;
